<template>
  <footer class="footer">
    <section class="footer-nav">
      <div class="container">
        <div class="columns">
          <div class="column is-3">
            <app-logo></app-logo>
            <p>FunLearning.com is the online marketplace for early education solutions developed by the <a href="https://funacademy.fi/" target="_blank">Fun Academy</a>.
              They are designed to spark curiosity and instill a passion for learning in preschoolers.</p>
          </div>

          <div class="column is-2">
            <div class="footer-link-list">
              <h5 class="footer-link-title">Products</h5>
              <router-link class="footer-link-item" :to="{ name: 'kinder' }">Kindergarten</router-link>
              <router-link class="footer-link-item" :to="{ name: 'prof-dev' }">Professional Development</router-link>
              <router-link class="footer-link-item" :to="{ name: 'camps' }">Camps</router-link>
              <router-link class="footer-link-item" :to="{ name: 'future-explorers' }">Programs</router-link>
              <router-link class="footer-link-item" :to="{ name: 'resources' }">Free Resources</router-link>
            </div>
          </div>

          <div class="column is-2">
            <div class="footer-link-list">
              <h5 class="footer-link-title">Free Resources</h5>
              <router-link class="footer-link-item" :to="{ name: 'resources', query: { types: [1] } }">Printables</router-link>
              <router-link class="footer-link-item" :to="{ name: 'resources', query: { types: [2] } }">Activities</router-link>
              <router-link class="footer-link-item" :to="{ name: 'resources', query: { types: [3] } }">Story Time</router-link>
              <router-link class="footer-link-item" :to="{ name: 'resources', query: { types: [4] } }">Songs and Music</router-link>
              <router-link class="footer-link-item" :to="{ name: 'resources', query: { types: [5] } }">Videos</router-link>
              <router-link class="footer-link-item" :to="{ name: 'resources', query: { types: [6] } }">Games and Apps</router-link>
            </div>
          </div>

          <div class="column is-2">
            <div class="footer-link-list">
              <h5 class="footer-link-title">About us</h5>
              <router-link class="footer-link-item" :to="{ name: 'about-us' }">About funlearning.com</router-link>
              <router-link class="footer-link-item" :to="{ name: 'testimonies' }">Testimonies</router-link>
              <router-link class="footer-link-item" :to="{ name: 'contact' }">Contact us</router-link>
              <router-link class="footer-link-item" :to="{ name: 'privacy' }">Privacy Policy</router-link>
              <router-link class="footer-link-item" :to="{ name: 'termsofuse' }">Terms of Use</router-link>
            </div>
          </div>

          <div class="column is-3">
            <div class="box footer-signin" v-if="!userIsAuthenticated">
              <h2>Sign In</h2>
              <p>Explore our ever changing collection of resources and plan your Fun Learning journey now!</p>
              <router-link class="button button-medium" :to="{ name: 'login' }">Sign In</router-link>
            </div>
          </div>

        </div>
      </div>
    </section>

    <section class="footer-copyright">
      <div class="container">
        <div class="columns">
          <div class="column is-8 social">
            <span>Follow us: </span>
            <a href="https://www.facebook.com/funacademyltd/" class="link" target="_blank"><i class="fab fa-facebook"></i></a>
            <a href="https://www.instagram.com/funacademycom/" class="link" target="_blank"><i class="fab fa-instagram"></i></a>
            <a href="https://twitter.com/funacademycom" class="link" target="_blank"><i class="fab fa-twitter"></i></a>
            <a href="https://www.linkedin.com/company/fun-academy-ltd-/" class="link" target="_blank"><i class="fab fa-linkedin"></i></a>
          </div>

          <div class="column is-4">
            <span>© 2018 <a href="https://funacademy.fi/" target="_blank">Fun Academy Oy</a>. All rights reserved.</span>
          </div>
        </div>
      </div>
    </section>
  </footer>
</template>

<script>
import AppLogo from '@/components/AppLogo'
export default {
  name: 'app-footer',

  components: {
    AppLogo
  },

  computed: {
    userIsAuthenticated () {
      return this.$store.state.isAuthenticated
    }
  }
}
</script>

<style lang="scss">

.footer {
  box-shadow: 0 -1px 0 0 #E4E5E9;

  .footer-link-item {
    display: block;
  }

  .footer-signin {
    h2 {
      font-size: 1.3rem;
      margin-bottom: 0.8rem;
    }
    .button {
      margin-top: 2rem;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/AppFooter.vue